const autoNgTemplateLoaderTemplate1 = require('./endpointSelector.html');

angular.module('shbdeployer.app').component('endpointSelector', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'EndpointSelectorController',
  bindings: {
    model: '=',
    endpoints: '<',
    groups: '<',
  },
});
